import type { Ticket } from './types'

/** The desk that called a missed customer. engine.NoShow clears calledToCounterId,
 *  but the called piece of work (transactions[i].counterId) still names the desk. */
export function missedAt(t: Pick<Ticket, 'transactions' | 'currentTransaction' | 'calledToCounterId'>): string | undefined {
  return t.transactions[t.currentTransaction]?.counterId || t.calledToCounterId || undefined
}
